import {io} from 'socket.io-client';

// const socket = new io('https://creatbase-dev.onrender.com', {
//   autoConnect: true,
//   withCredentials: true,
// });https://pureworker.onrender.com

// https://api.pureworker.com/ https://pureworker-3482.onrender.com
// const socket = io('https://pureworker-api.onrender.com/api', {
//   autoConnect: true,
//   withCredentials: false,
//   transports: ['websocket'],
  // extraHeaders: {
  //   'Access-Control-Allow-Origin': '*',
  // },
// });
// const socket = io('https://pureworker-api.onrender.com', {
//   autoConnect: true,
//   withCredentials: false,
//   transports: ['websocket'],
//   extraHeaders: {
//     'Access-Control-Allow-Origin': '*',
//   },
// });
export const socket = io('https://pureworker-api.onrender.com', {
  withCredentials: false,
  // autoConnect: false,
  transports:['websocket']
});


export default socket;
